var d = Object.defineProperty;
var p = (i, t, e) => t in i ? d(i, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : i[t] = e;
var o = (i, t, e) => (p(i, typeof t != "symbol" ? t + "" : t, e), e);
import { canUseFetch as l } from "./utils/canUseFetch.js";
import { getGlobal as u } from "./utils/getGlobal.js";
const g = {
  mode: "cors"
}, a = {
  get: "GET",
  post: "POST",
  put: "PUT",
  delete: "DELETE"
};
class w {
  constructor(t, e) {
    o(this, "isFetchAPI");
    o(this, "globals");
    o(this, "reqInit");
    o(this, "options");
    o(this, "headers");
    this.isFetchAPI = l(), this.globals = globalThis || u(), this.options = t || {}, this.reqInit = { ...g, ...e }, this.headers = new Headers(), this.initHeaders();
  }
  get(t, e) {
    const s = this.mergeMethod(this.reqInit, a.get), r = this.createFetchUrl(t, e);
    return this.doFetch(r, s);
  }
  post(t, e) {
    return this.ppd(a.post, t, e);
  }
  put(t, e) {
    return this.ppd(a.put, t, e);
  }
  delete(t, e) {
    return this.ppd(a.delete, t, e);
  }
  fetch(t, e) {
    if (!this.isFetchAPI)
      throw new Error("Fetch API is not supported");
    return this.globals.fetch(t, e);
  }
  setCustomHeaders(t, e) {
    !t || !e || (this.headers.set(t, e), this.mergeHeaders(this.headers, this.reqInit));
  }
  batchSetCustomHeaders(t) {
    if (!t || typeof t != "object")
      return;
    Object.keys(t).forEach((s) => {
      this.headers.set(s, t[s]);
    }), this.mergeHeaders(this.headers, this.reqInit);
  }
  initHeaders() {
    this.headers.append("Content-Type", "application/json"), this.mergeHeaders(this.headers, this.reqInit);
  }
  mergeHeaders(t, e) {
    const s = {};
    t.forEach((r, n) => {
      s[n] = r;
    }), e.headers = { ...e.headers, ...s };
  }
  ppd(t, e, s) {
    const r = this.mergeBody(this.mergeMethod(this.reqInit, t), s), n = this.createFetchUrl(e);
    return this.doFetch(n, r);
  }
  async doFetch(t, e) {
    try {
      const s = await this.fetch(t, e);
      if (!s.ok)
        if (s.status === 401 || s.status === 403) {
          const h = {
            status: s.status,
            statusText: s.statusText
          };
          throw new c(h, "Access denied");
        } else {
          const h = {
            status: s.status,
            statusText: s.statusText
          };
          throw new c(h, "Unkown error");
        }
      const r = s.headers.get("content-type");
      if (!r || !r.includes("application/json"))
        throw new TypeError("Oops, we haven't got JSON!");
      return await s.json();
    } catch (s) {
      console.error("Error:", s), this.options.errorHandler && this.options.errorHandler(s);
    }
  }
  mergeMethod(t, e) {
    return { ...t, method: e };
  }
  mergeBody(t, e) {
    return e ? { ...t, body: JSON.stringify(e) } : t;
  }
  createFetchUrl(t, e) {
    const s = new URL(this.options.baseUrl ? this.options.baseUrl + t : t);
    return e && (s.search = new URLSearchParams(e).toString()), s;
  }
}
class c extends Error {
  constructor(e, s, r) {
    super(s, r);
    o(this, "name");
    o(this, "payload");
    o(this, "date");
    this.name = "FalconError", this.payload = e, this.date = /* @__PURE__ */ new Date();
  }
  getMsg() {
    return this.message;
  }
  getPayload() {
    return this.payload;
  }
}
export {
  w as Falcon
};
